import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import EmptyList from 'src/components/templates/EmptyList.template';
import AppAssets from 'src/constants/appAssets';
import useI18n from 'src/modules/translations/hooks/useI18n';
const EmptyTabsList = ({ editable = true, onAddTab }) => {
    const { translate } = useI18n();
    return (React.createElement(EmptyList, { style: { alignSelf: 'center' }, message: translate('No tabs found'), imgSrc: AppAssets.noteTabsEmptyList }, editable && onAddTab && (React.createElement(Button, { LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }), onPress: onAddTab }, translate('Add Tab')))));
};
export default EmptyTabsList;
